<template>
  <div class="l-content">
    <main class="l-editor">
      <slot />
    </main>

    <messages class="c-messages--l-editor" />
    <modals />
  </div>
</template>

<script>
import Messages from '@/components/Messages/Messages.vue'
import Modals from '@/components/Modals/Modals.vue'

export default {
  name: 'Editor',

  components: { Messages, Modals },

  mounted () {
    /**
     * Add editor class on body necessary remove overflow-y
     */
    this.toggleBodyClass('addClass', 'is-noscroll')
  },

  beforeDestroy () {
    /**
     * Remove editor class on body
     */
    this.toggleBodyClass('removeClass', 'is-noscroll')
  },

  methods: {
    toggleBodyClass (addRemoveClass, className) {
      const el = document.body

      if (addRemoveClass === 'addClass') {
        el.classList.add(className)
      } else {
        el.classList.remove(className)
      }
    }
  }
}
</script>
